import React from 'react';
import tomImage from '../../../img/tom.png';
import './OrtomBrief.scss';

const OrtomBrief = () => (
  <div className="container mobile-container">
    <div className="columns is-fullhd">
      <div className="column is-half tomImage">
        <img className="" src={tomImage} alt="Tom Liptrot, founder of Ortom AI consultancy, Manchester" style={{ height: 'auto', width: '100%' }} />
      </div>
      <div className="column is-half textWithButton ">
        <div>
          <h3>Twenty years of taking AI from prototype to production</h3>
          <br />
          <p>
          Ortom is led by Tom Liptrot, an AI engineer and consultant based in Manchester. He works with startups and scaleups to build agentic AI systems that hold up in production.
          </p>
          <br />
          <p>
          Before founding Ortom, Tom was Head of Data Science at Peak AI. There he grew data science revenue from £100k to £3.5m ARR and built the team that delivered it. Earlier in his career he worked on personalised medicine and clinical NLP at AstraZeneca and The Christie NHS Foundation Trust, and he has published peer-reviewed research in cancer genomics and clinical NLP.
          </p>
          <br />
          <p>
          Today his work centres on production agentic systems: tool-using agents, RAG and structured extraction, built with Python, FastAPI and PydanticAI across AWS, GCP and Azure. He deploys in the cloud, on-premise or on-device as the product requires.
          </p>
          <br />
          <p>
          He&apos;s technical enough to write the code and commercial enough to tell you when not to build something.
          </p>
        </div>
      </div>
    </div>
    <div className="gap" />
  </div>
);

export default OrtomBrief;
